import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative',
    checkboxContainer: 'relative flex items-center',
    checkbox: 'hidden',
    label:
      'heading-xs-bold flex-center group-[.shadow-header]:bg-bg-items-white flex h-10 w-fit cursor-pointer rounded-full bg-white px-6 text-base leading-[1.2] leading-none font-normal tracking-wider whitespace-nowrap'
  },
  variants: {
    disabled: { true: {}, false: {} },
    checked: {
      true: {},
      false: {}
    },
    color: { white: {} }
  },
  compoundSlots: [
    {
      slots: ['label'],
      disabled: true,
      class: 'text-inactive group-hover:text-inactive cursor-not-allowed'
    },
    {
      slots: ['label'],
      checked: true,
      class:
        'bg-text-main hover:bg-primary/80 text-text-main-inversion! group-[.shadow-header]:bg-text-main'
    },
    {
      slots: ['label'],
      checked: false,
      class: 'hover:text-brand-400'
    },
    {
      slots: ['label'],
      checked: false,
      color: 'white',
      class: 'bg-bg-items-grey hover:bg-accent hover:text-primary'
    }
  ]
});
